import { Label } from '@perch-labs/shrike';
import styled from 'styled-components';
import { Container } from '~/components/layout';

export const StyledContainer = styled(Container)`
  background-color: ${props => props.theme.colors.background.tertiary};
  border-radius: ${props => props.theme.borderRadii.small};
  font-size: ${props => props.theme.fontSizes[500]};
  font-family: ${props => props.theme.fontFamilies.main.regular};
  margin-top: 8px;
  opacity: ${props => props.theme.opacities.medium};
  padding: 16px;
`;

export const StyledLabel = styled(Label)`
  display: block;
  width: 100%;
`;
